import ModalTemplate from "../../../components/modal/modalTemplate";

const ProfileImageView = ({show, closeModal, imagePath}) => {
    return(
        <ModalTemplate
            show={show}
            closeFun={closeModal}
            centered
            title={"Profile Image"}
            body={
                 <div className="card card-plain">
                    <div className="card-header p-2 position-relative z-index-2 bg-transparent text-center">
                        <div className="d-block blur-shadow-image">
                            <img
                                src={imagePath}
                                alt={"profile_image"}
                                className="img-fluid shadow border-radius-lg w-100"
                                style={{
                                    maxHeight: "70vh",
                                    objectFit: "contain",
                                    display: "block",
                                    margin: "0 auto",
                                }}
                            />
                        </div>
                    </div>
                </div>
            }
        />
    );
};

export default ProfileImageView;